// 租赁方案类型
export const PLAN_TYPE = {
  // 个人
  PERSON: 1,
  // 企业
  ENTER: 2,
}
// 租赁方案类型文案
export const PLAN_TYPE_TEXT = {
  [PLAN_TYPE.PERSON]: '个人',
  [PLAN_TYPE.ENTER]: '企业',
}

// 编辑模式
export const MODE_TYPE = {
  // 新增
  ADD: 'add',
  // 编辑
  EDIT: 'edit',
  // 复制
  COPY: 'copy',
}
// 编辑模式文案
export const MODE_TYPE_TEXT = {
  [MODE_TYPE.ADD]: '新增',
  [MODE_TYPE.EDIT]: '编辑',
  [MODE_TYPE.COPY]: '新增', // 复制和新增文案一致
}
